module.exports = __webpack_public_path__ + "static/img/tick-yellow.19053cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/tick-yellow.svg
// module id = qDSQ
// module chunks = 0